const SELECTORS = {
  swiperContainer: '.naviagtion-list-slider',
  hideSection: '.columns-teaser--hide-section',
  columnsTeaserSection: 'shopify-section--columns-teaser',
  columnsTeaserSectionHidden: 'shopify-section--columns-teaser--hidden',
  columnsTeasersWithId: '.columns-teaser[id]',
  sliderButton: '.featured-collection-slider__navigation-list-item',
};
/**
 * Initialize swiper
 *
 * @param {object} Swiper swiper class object
 */
const initCategorySlider = (Swiper) => {
  const swiperContainer = document.querySelector(SELECTORS.swiperContainer);
  const swiperOptions = {
    spaceBetween: 10,
    slidesPerView: 'auto',
    watchOverflow: false,
  };
  if (swiperContainer && Swiper) {
    // eslint-disable-next-line no-unused-vars
    const categorySwiper = new Swiper(swiperContainer, swiperOptions);
  }
};
document.addEventListener('DOMContentLoaded', () => {
  const hideElements = document.querySelectorAll(SELECTORS.hideSection);
  let activeType = 'suplements';
  const featuredCollections = document.querySelectorAll('.multiple .featured-collection-slider__content');
  const sectionTeaserAll = document.querySelectorAll('.connectionWithSlider');
  const cosmeticsBtn = document.querySelectorAll('.swiper-slide.cosmetics');
  const suplementBtns = document.querySelectorAll('.swiper-slide.suplements');

  hideElements.forEach((element) => {
    if (element.parentNode && element.parentNode.classList.contains(SELECTORS.columnsTeaserSection)) {
      element.parentNode.classList.add(SELECTORS.columnsTeaserSectionHidden);
    }
  });

  const sliderButton = document.querySelectorAll(SELECTORS.sliderButton);
  const productTypeBtn = document.querySelectorAll('.btn-product-type');

  sliderButton.forEach((button) => {
    button.addEventListener('click', () => {
      const buttonTeaser = button.getAttribute('data-teaser');
      const columnsTeaserId = buttonTeaser;
      const columnsTeaser = document.getElementById(columnsTeaserId);

      if (columnsTeaser && buttonTeaser === columnsTeaser.id && columnsTeaser.parentNode.classList.contains(SELECTORS.columnsTeaserSectionHidden)) {
        const columnsTeasersWithId = document.querySelectorAll(SELECTORS.columnsTeasersWithId);
        columnsTeasersWithId.forEach((item) => {
          if (!item.parentNode.classList.contains(SELECTORS.columnsTeaserSectionHidden)) {
            item.parentNode.classList.add(SELECTORS.columnsTeaserSectionHidden);
          }
        });
        columnsTeaser.parentNode.classList.remove(SELECTORS.columnsTeaserSectionHidden);
      }
    });
  });

  productTypeBtn.forEach((button) => {
    button.addEventListener('click', (e) => {
      activeType = e.currentTarget.dataset.productType;
      if (activeType === 'cosmetics') {
        sectionTeaserAll.forEach((teaserSection) => {
          teaserSection.classList.add('hidden');
        });
        suplementBtns.forEach((btn) => {
          btn.classList.add('hidden');
        });
        cosmeticsBtn.forEach((btn) => {
          btn.classList.remove('hidden');
          const innerBtn = btn.querySelector('button');
          innerBtn.classList.add('selected');
        });

        featuredCollections.forEach((collection) => {
          const { collectionType } = collection.dataset;
          if (collectionType !== 'collection_cosmetics') {
            collection.classList.add('hidden');
          } else {
            collection.classList.remove('hidden');
            collection.style.display = 'flex';
            collection.style.opacity = '1';
          }
        });
      } else {
        sectionTeaserAll.forEach((teaserSection) => {
          teaserSection.classList.remove('hidden');
        });
        suplementBtns.forEach((btn) => {
          btn.classList.remove('hidden');
        });
        cosmeticsBtn.forEach((btn) => {
          btn.classList.add('hidden');
        });
        featuredCollections.forEach((collection) => {
          const { collectionType } = collection.dataset;
          if (collectionType !== 'collection_cosmetics') {
            collection.classList.remove('hidden');
          } else {
            collection.classList.add('hidden');
          }
        });
      }

      productTypeBtn.forEach((btn) => {
        btn.classList.remove('selected');
      });
      const currentElement = e.currentTarget;
      currentElement.classList.add('selected');
    });
  });
  window.LoadSwiper.then((module) => {
    initCategorySlider(module.Swiper);
  });
});
